import { render, staticRenderFns } from "./UpdateSubstance.vue?vue&type=template&id=547623fb&scoped=true&"
import script from "./UpdateSubstance.vue?vue&type=script&lang=js&"
export * from "./UpdateSubstance.vue?vue&type=script&lang=js&"
import style0 from "./UpdateSubstance.vue?vue&type=style&index=0&id=547623fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547623fb",
  null
  
)

export default component.exports